import React from 'react';
import { GenericDescriptionList } from 'web-ui-components/lib/data/lists';
import { ConditionalPanel } from 'web-ui-components/lib/layout/content';
import { Field } from 'react-final-form';
import { Content } from '../../../../infrastructure/content';
import PropTypes from '../../../../types';

const ChoosenAddress = ({ label, addressId, value }) => (
  <Content>
    {(content) => (
      <Field name={`${addressId}chosenAddressField`}>
        {() => (
          <Field name={`${addressId}chosenAddressField`}>
            {() => (
              <ConditionalPanel isVisible>
                <GenericDescriptionList
                  items={[
                    {
                      key: content[label],
                      value: value.replace(/,/g, '')
                    }
                  ]}
                />
              </ConditionalPanel>
            )}
          </Field>
        )}
      </Field>
    )}
  </Content>
);

ChoosenAddress.propTypes = {
  label: PropTypes.string.isRequired
};

export default ChoosenAddress;
